import { Component } from 'react';

import { type IModalProps } from './Modal'
import { ModalCardHeaderStyled } from './styles/ModalCardHeaderStyled'
import { TransparentIconButton } from '../../elements/Button'
import { Toolbar } from '../../elements/Toolbar'
import { Header } from '@ui/elements/Header'

interface IModalHeaderProps {
  id?: string
  /** Callback function when the close button is pressed */
  onClose?: IModalProps['onClose']
  /** Analytics ID for the close button. */
  analyticsId?: string
}

export class ModalHeader extends Component<IModalHeaderProps> {
  render() {
    const { id, onClose, children, analyticsId } = this.props

    return (
      <ModalCardHeaderStyled haveCloseButton={!!onClose}>
        <Toolbar>
          <Header as='h3' id={id}>
            {children}
          </Header>
          <Toolbar.Fill />

          {!!onClose && (
            <TransparentIconButton
              icon='times'
              onClick={(e) => onClose(e, null)}
              className='header-close-btn'
              aria-label='Close'
              analyticsId={analyticsId}
            />
          )}
        </Toolbar>
      </ModalCardHeaderStyled>
    )
  }
}
